import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const GOOGLE_CALENDAR_LINK = "https://calendar.app.google/ULCXQLbU7iFtuVHh7";

export function openGoogleCalendar() {
  window.open(GOOGLE_CALENDAR_LINK, '_blank');
}
